import { FC } from "react";
import styled from "@emotion/styled";
import { useQuery } from "convex/react";
import { api } from "@/smart-views/client/api";

interface SmartViewDebugOverlayProps {
  smartViewId: string;
  onClose: () => void;
}

export const SmartViewDebugOverlay: FC<SmartViewDebugOverlayProps> = ({ smartViewId, onClose }) => {
  const snapshot = useQuery(api.smartViews.client.debugSnapshot, { smartViewId });

  return (
    <Overlay onClick={onClose}>
      <Panel onClick={e => e.stopPropagation()}>
        <Header>
          <Title>Convex backend snapshot</Title>
          <Hint>cmd+shift+D to close</Hint>
        </Header>
        <Body>
          <pre>{JSON.stringify(snapshot, null, 2)}</pre>
        </Body>
      </Panel>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
`;

const Panel = styled.div`
  width: min(720px, 60vw);
  background: #0d0d0d;
  color: #d6d6d6;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #2a2a2a;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.div`
  font-weight: 600;
  color: #fff;
`;

const Hint = styled.div`
  color: #888;
`;

const Body = styled.div`
  flex: 1;
  overflow: auto;
  padding: 16px;
  pre {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
  }
`;
